import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', minHeight: '100vh', fontFamily: 'system-ui, sans-serif',
        }}>
          <h1 style={{ fontSize: 24, marginBottom: 16, color: '#374151' }}>發生錯誤</h1>
          <p style={{ color: '#6b7280', marginBottom: 24 }}>頁面發生未預期的錯誤，請重新整理頁面</p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '10px 24px', borderRadius: 8, border: 'none',
              background: '#FF6B35', color: 'white', fontSize: 15,
              cursor: 'pointer', fontWeight: 500,
            }}
          >
            重新整理
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
